const BasicCoupon = ({
    number,
    topNote,
    title,
    description,
    redeemableBy,
    validUntil,
    signature,
    theme,
    handwritten
}) => {
    return (
        <div className={`coupon theme-${theme} ${handwritten ? "handwritten" : ""}`}>
            <div className="cut-marks" />
            <div className="coupon-number">#{number}</div>
            <div className="top-note">{topNote}</div>
            <h1 className="title">{title}</h1>
            <p className="description">{description}</p>
            <div className="details">
                <div>
                    <span className="label">Redeemable by</span>
                    <span className="value">{redeemableBy}</span>
                </div>
                <div>
                    <span className="label">Valid until</span>
                    <span className="value">{validUntil}</span>
                </div>
            </div>
            <div className="signature">
                Love,<br />
                <strong>{signature}</strong>
            </div>
        </div>
    );
};

export default BasicCoupon;
